/* eslint-disable react/forbid-prop-types */
/* eslint-disable */

import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import api from "api";
import PropTypes from "prop-types";
import { useAuth } from "context/auth";
import useRoles from "customHooks/useRoles";
import { NotificationManager } from "react-notifications";
import { useLoading, handleLoading } from "context/LoadingContext";
import addNewLog from "utils/addNewLog";
import { generateTextFromJson } from "utils/generateTextFromJson";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function PrintParcels(props) {
  // TODO make your all PrintParcels calls give the right props
  const {
    printData,
    toggleDialog,
    isDraft,
    withCheck,
    isOfficial,
    isGovernmentWork,
    isPrivateOfficialWork,
    WithCreatePayment,
    withEmployee
  } = props;    
  const [auth] = useAuth();
  const { userDetails } = auth;
  const { roles } = useRoles();

  const {
    register,
    formState: { errors },
    trigger,
    getValues,
    watch,
    setValue,
  } = useForm();

  const {
    register: paymentNumberRegister,
    trigger: paymentNumberTrigger,
    getValues: paymentNumberGetValues,
    // setValue: paymentNumberSetValue,
    // formState: { errors: paymentNumberErrors },
  } = useForm();
  const { userNationalId } = watch();
  const [, loadingDispatch] = useLoading();
  const [scale, setScale] = useState(2000);
  const [parcelAreaAndShare, setParcelAreaAndShare] = useState({});
  const [landOwners, setLandOwners] = useState([]);
  useEffect(() => {
    (async () => {
      if (roles.employeeOrManager||roles.employee) {
        try {
          handleLoading(loadingDispatch, true);

          const res = await api.post("lands/dls", {
            dlsKey: printData?.data?.dlsKey || printData?.data?.DLS_KEY,
          });

          setParcelAreaAndShare(res?.data?.data?.land);
          const landOwnersRes = await api.post("lands/owner", {
            dlsKey: printData?.dlsKey || printData?.DLS_KEY,
          });
          setLandOwners(
            landOwnersRes.data?.data?.list?.filter((item) => item?.trim()) || []
          );
        } catch (error) {
          NotificationManager.error("يوجد فصل بالربط مع دائرة الأراضي");
          toggleDialog();
        }
        handleLoading(loadingDispatch, false);
      }
    })();
    if (roles.people) {
      api
        .post("lands/getLandInfoUsingNatId", {
          dlsKey: printData?.dlsKey || printData?.DLS_KEY,
          natId: auth.userDetails.details.userNationalId,
        })
        .then((res) => {
          handleLoading(loadingDispatch, false);
          setParcelAreaAndShare(res.data?.land);
        })
        .catch(() => {
          NotificationManager.error("يوجد فصل بالربط مع دائرة الأراضي");
          toggleDialog();
        })
        .finally(() => {
          handleLoading(loadingDispatch, false);
        });
    }
    return () => {
      handleLoading(loadingDispatch, false);
    };
  }, [roles]);

  const handleCreatePaymentNumber = async () => {
    const values = paymentNumberGetValues();
    const { landOwner } = getValues();
    const noErrorPhone = await paymentNumberTrigger("phoneNumber");
    const noErrorRequesterName = await trigger("landOwner");
    // trigger;
    // getValues;
    if (!noErrorPhone) {
      NotificationManager.error("الرجاء ادخال رقم الهاتف و ادخاله بشكل صحيح");
      return;
    }
    if (!noErrorRequesterName) {
      NotificationManager.error("الرجاء ادخال اسم المقدم");
      return;
    }    
    
    try {      
      const newPaymentRes = await api.put("payment/new", {
        dlsKey: printData?.dlsKey || printData?.DLS_KEY,
        zoneCodeArray:printData?.zoneCodeArray,
        phoneNumber: values.phoneNumber,
        parcelId: printData?.PARCEL_ID,
        hodCode: printData?.HOD_CODE,
        landOwner: landOwner,
      });
      setValue("ePaymentNumber", newPaymentRes.data?.data?.ePaymentNumber);
      NotificationManager.success("تم أصدار رقم الدفع الالكتروني");

    } catch (error) {
      if (error?.response?.data?.message) {
        ErrorHandelFunctionApp(error)
      } else
        NotificationManager.error(
          "حدث خطأ ما اثناء انشاء رقم الدفع الالكتروني"
        );
    }
  };

  const [loadingCreatePayment,setloadingCreatePayment]=useState(false);

  const CreatePaymentCode=async ()=>{
    if(loadingCreatePayment)return
    setloadingCreatePayment(true)
    const values = paymentNumberGetValues();
    const { landOwner } = getValues();
    const noErrorPhone = await paymentNumberTrigger("phoneNumber");
    const noErrorRequesterName = await trigger("landOwner");
    // trigger;
    // getValues;
    if (!noErrorPhone) {
      NotificationManager.error("الرجاء ادخال رقم الهاتف و ادخاله بشكل صحيح");
      return;
    }
    if (!noErrorRequesterName) {
      NotificationManager.error("الرجاء ادخال اسم المقدم");
      return;
    }    
    
    try {      
      const newPaymentRes = await api.put("payment/new", {
        dlsKey: printData?.dlsKey || printData?.DLS_KEY,
        zoneCodeArray:printData?.zoneCodeArray,
        phoneNumber: values.phoneNumber,
        parcelId: printData?.PARCEL_ID,
        hodCode: printData?.HOD_CODE,
        landOwner: landOwner,
        userNationalId:watch()?.userNationalId
      });
      NotificationManager.success("تم أصدار رقم الدفع الالكتروني");
    } catch (error) {
      if (error?.response?.data?.message) {
        ErrorHandelFunctionApp(error)
      } else
        NotificationManager.error(
          "حدث خطأ ما اثناء انشاء رقم الدفع الالكتروني"
        );
    }finally{
      setloadingCreatePayment(false)
    }
  }

  const handlePrint = async () => {
    try {
      const noError = await trigger();
      if (roles.employeeOrManager && !noError) {
        return;
      }
      handleLoading(loadingDispatch, true);
      const { ePaymentNumber, bookRequesterName, bookNumber, landOwner } =
        getValues();
      let { citizenName = "" } = getValues();
      let Data=getValues();
      
      if (roles.employeeOrManager && withCheck && !isGovernmentWork) {
        const landsRes = await api.post("lands", { userNationalId });
        const parcelDls = printData?.dlsKey || printData?.DLS_KEY;
        
        if (
          !landsRes.data.data.list
            .map((item) => item.dlsKey)
            .includes(parcelDls)
        ) {
          NotificationManager.error("صاحب رقم الوطني المدخل لا يملك هذه الأرض");
          handleLoading(loadingDispatch, false);
          return;
        }

        citizenName = citizenName || landsRes.data.data.fullName;
        const paymentCheckRes = await api.post("payment/check", {
          userNationalId,
          billingNumber: ePaymentNumber,
        });
        if (paymentCheckRes.status === 204) {
          NotificationManager.error("رقم دفع الكتروني غير موجود");
          handleLoading(loadingDispatch, false);
          return;
        }
        if (!paymentCheckRes?.data?.data?.paid) {
          NotificationManager.error("لم يتم دفع الفاتورة");
          handleLoading(loadingDispatch, false);
          return;
        }
      } else if (roles.employeeOrManager && userNationalId) {
        const landsRes = await api.post("lands", {
          userNationalId,
        });

        
        if (
          landsRes.data.data.list
            .map((item) => item.dlsKey)
            .includes(printData.DLS_KEY)
        )
          citizenName = landsRes.data.data.fullName;
      } else if (roles.people) {
        citizenName = userDetails.details.fullName;
      }


      let privateOfficialWorkReceiptNumber;
      if (roles.employeeOrManager && isPrivateOfficialWork) {
        const paymentCheckRes = await api.post("payment/check", {
          billingNumber: isPrivateOfficialWork
            ? ePaymentNumber
            : printData.ePaymentNumber,
        });

        const paymentCheckData = paymentCheckRes?.data?.data;
        if (!paymentCheckData?.paid) {
          handleLoading(loadingDispatch, false);
          NotificationManager.error("لم يتم دفع الفاتورة, الرجاء الدفع");
          return;
        }
        privateOfficialWorkReceiptNumber = paymentCheckData?.receiptNumber;
      }

      const printRes = await api.post(
        "pdf/petra",
        {
          empName: `${userDetails.details.firstName} ${userDetails.details.lastName}`,
          dlsKey: printData?.dlsKey || printData?.DLS_KEY || "",
          scale,
          isDraft: isDraft ? 1 : 0,
          isOfficial: isOfficial ? 1 : 0,
          isGovernmentWork: isGovernmentWork ? 1 : 0,
          area: parcelAreaAndShare?.area,
          userNationalId:userNationalId,
          ePaymentNumber: !printData.ePaymentNumber
            ? ePaymentNumber
            : printData.ePaymentNumber,
          receiptNumber:
            privateOfficialWorkReceiptNumber || printData.receiptNumber,
          bookRequesterName,
          bookNumber,
          isPrivateOfficialWork: isPrivateOfficialWork||withEmployee ? 1 : 0,
          landOwner:roles.people?citizenName:landOwner,
        },
        { headers: { "esri-token": localStorage.getItem("esriToken") } }
      );
      setTimeout(() => {
        const link = document.createElement("a");
        link.href = printRes.data.data.url;
        link.target = "_blank";
        link.click();
      }, 2000);

      if (roles.employeeOrManager) {
        await addNewLog({
          ipAddress: auth.ipAddress,
          hostname: auth.hostname,
          logDescription: `${generateTextFromJson(printData, printData?.typePrintValue)}`
        });
      }
      toggleDialog();
    } catch (error) {   
      ErrorHandelFunctionApp(error) 
    }
    handleLoading(loadingDispatch, false);
  };

  const handleScaleChange = (e) => {
    setScale(e.target.value);
  };

  return (
    <div>
      {(roles.employeeOrManager && withCheck) && (
        <>
          <Form.Group
            className="mb-3 input input-md"
            controlId="userNationalId"
          >
            <Form.Label>الرقم الوطني لصاحب الأرض</Form.Label>
            <Form.Control
              autoComplete="off"
              type="text"
              {...register("userNationalId", {
                required: "الرجاء ادخال الرقم الوطني",
                pattern: {
                  value: /^[0-9]*$/,
                  message: "حقل يجب أن يحتوي فقط على أرقام",
                },
                minLength: {
                  value: 10,
                  message: "يجب أن يحتوي الحقل على 10 ارقام",
                },
                maxLength: {
                  value: 10,
                  message: "يجب أن يحتوي الحقل على 10 ارقام",
                },
              })}
            />
            {errors.userNationalId && (
              <Form.Text className="text-danger">
                {errors.userNationalId.message}
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group
            className="mb-3 input input-md"
            controlId="ePaymentNumber"
          >
            <Form.Label>رقم الدفع الالكتروني</Form.Label>
            <Form.Control
              autoComplete="off"
              type="text"
              {...register("ePaymentNumber", {
                required: "الرجاء ادخال رقم الدفع الالكتروني",
                pattern: {
                  value: /^[0-9]*$/,
                  message: "حقل يجب أن يحتوي فقط على أرقام",
                },
              })}
            />
            {errors.ePaymentNumber && (
              <Form.Text className="text-danger">
                {errors.ePaymentNumber.message}
              </Form.Text>
            )}
          </Form.Group>
        </>
      )}
      {roles.employeeOrManager && isGovernmentWork && (
        <>
          <Form.Group className="mb-3 input input-md" controlId="bookNumber">
            <Form.Label>رقم الكتاب الوارد</Form.Label>
            <Form.Control
              autoComplete="off"
              type="text"
              {...register("bookNumber", {
                required: "الرجاء ادخال الحقل",
                // pattern: {
                //   value: /^[0-9]*$/,
                //   message: "حقل يجب أن يحتوي فقط على أرقام",
                // },
              })}
            />
            {errors.bookNumber && (
              <Form.Text className="text-danger">
                {errors.bookNumber.message}
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group className="mb-3 input input-md" controlId="landOwner">
            <Form.Label>اسم المالك</Form.Label>
            {landOwners?.length ? (
              <Form.Select
                {...register("landOwner", {
                  required: "الرجاء ادخال الحقل",
                })}
              >
                <option value="">الرجاء الاختيار</option>
                {landOwners?.map?.((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            ) : (
              <Form.Control
                autoComplete="off"
                type="text"
                {...register("landOwner", {
                  required: "الرجاء ادخال الحقل",
                })}
                placeholder="لا يوجد مالك معرف لهذه الأرض يمكنك كتابة اسم يدويا"
              />
            )}
            {errors.landOwner && (
              <Form.Text className="text-danger">
                {errors.landOwner.message}
              </Form.Text>
            )}
          </Form.Group>
        </>
      )}
      {roles.employeeOrManager && isPrivateOfficialWork && (
        <>
          <Form.Group className="mb-3 input input-md" controlId="landOwner">
            <Form.Label>اسم المالك</Form.Label>
            {landOwners?.length ? (
              <Form.Select
                {...register("landOwner", {
                  required: "الرجاء ادخال الحقل",
                })}
              >
                <option value="">الرجاء الاختيار</option>
                {landOwners?.map?.((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            ) : (
              <Form.Control
                autoComplete="off"
                type="text"
                {...register("landOwner", {
                  required: "الرجاء ادخال الحقل",
                })}
                placeholder="لا يوجد مالك معرف لهذه الأرض يمكنك كتابة اسم يدويا"
              />
            )}
            {errors.landOwner && (
              <Form.Text className="text-danger">
                {errors.landOwner.message}
              </Form.Text>
            )}
          </Form.Group>
          <div style={{ display: "flex", gap: "1rem" }} className="mb-3">
            <Form.Group
              className=" input input-md"
              style={{ flex: "1" }}
              controlId="phoneNumber"
            >
              <Form.Label>رقم الهاتف للمقدم</Form.Label>
              <Form.Control
                {...paymentNumberRegister("phoneNumber", {
                  required: "الرجاء رقم الهاتف",
                  pattern: {
                    value: /^078[0-9]*$|^077[0-9]*$|^079[0-9]*$/,
                    message: "الرجاء ادخال رقم هاتف صحيح",
                  },
                  minLength: {
                    value: 10,
                    message: "يجب أن يحتوي الحقل على 10 ارقام",
                  },
                  maxLength: {
                    value: 10,
                    message: "يجب أن يحتوي الحقل على 10 ارقام",
                  },
                })}
              />
            </Form.Group>
            <button
              className="btn btn--primary align-self-end"
              type="button"
              onClick={handleCreatePaymentNumber}
            >
              انشاء رقم دفع الكتروني
            </button>
          </div>
          <Form.Group
            className="mb-3 input input-md"
            controlId="ePaymentNumber"
          >
            <Form.Label>رقم الدفع الالكتروني</Form.Label>
            <Form.Control
              autoComplete="off"
              type="text"
              {...register("ePaymentNumber", {
                required: "الرجاء ادخال رقم الدفع الالكتروني",
                pattern: {
                  value: /^[0-9]*$/,
                  message: "حقل يجب أن يحتوي فقط على أرقام",
                },
              })}
            />
            {errors.ePaymentNumber && (
              <Form.Text className="text-danger">
                {errors.ePaymentNumber.message}
              </Form.Text>
            )}
          </Form.Group>
          {/* <Form.Group className="mb-3 input input-md" controlId="landOwner">
            <Form.Label>اسم المالك</Form.Label>
            {landOwners?.length ? (
              <Form.Select
                {...register("landOwner", {
                  required: "الرجاء ادخال الحقل",
                })}
              >
                <option value="">الرجاء الاختيار</option>
                {landOwners?.map?.((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            ) : (
              <Form.Control
                autoComplete="off"
                type="text"
                {...register("landOwner", {
                  required: "الرجاء ادخال الحقل",
                })}
                placeholder="لا يوجد مالك معرف لهذه الأرض يمكنك كتابة اسم يدويا"
              />
            )}
            {errors.landOwner && (
              <Form.Text className="text-danger">
                {errors.landOwner.message}
              </Form.Text>
            )}
          </Form.Group> */}
          <Form.Group
            className="mb-3 input input-md"
            controlId="bookRequesterName"
          >
            <Form.Label>اسم مقدم الطلب</Form.Label>
            <Form.Control
              autoComplete="off"
              type="text"
              {...register("bookRequesterName", {
                required: "الرجاء ادخال الحقل",
              })}
            />
            {errors.bookRequesterName && (
              <Form.Text className="text-danger">
                {errors.bookRequesterName.message}
              </Form.Text>
            )}
          </Form.Group>
          <Form.Group className="mb-3 input input-md" controlId="bookNumber">
            <Form.Label>رقم الكتاب الوارد</Form.Label>
            <Form.Control
              autoComplete="off"
              type="text"
              {...register("bookNumber", {
                required: "الرجاء ادخال الحقل",
                // pattern: {
                //   value: /^[0-9]*$/,
                //   message: "حقل يجب أن يحتوي فقط على أرقام",
                // },
              })}
            />
            {errors.bookNumber && (
              <Form.Text className="text-danger">
                {errors.bookNumber.message}
              </Form.Text>
            )}
          </Form.Group>
        </>
      )}
      {roles.employeeOrManager &&
        !withCheck &&
        !isGovernmentWork &&
        !isPrivateOfficialWork && (
          <Form.Group
            className="mb-3 input input-md"
            controlId="userNationalId"
          >
            <Form.Label>الرقم الوطني لصاحب الأرض</Form.Label>
            <Form.Control
              autoComplete="off"
              type="text"
              {...register("userNationalId", {
                pattern: userNationalId
                  ? {
                      value: /^[0-9]*$/,
                      message: "حقل يجب أن يحتوي فقط على أرقام",
                    }
                  : null,
                minLength: userNationalId
                  ? {
                      value: 10,
                      message: "يجب أن يحتوي الحقل على 10 ارقام",
                    }
                  : null,
                maxLength: userNationalId
                  ? {
                      value: 10,
                      message: "يجب أن يحتوي الحقل على 10 ارقام",
                    }
                  : null,
              })}
            />
            {userNationalId && errors.userNationalId && (
              <Form.Text className="text-danger">
                {errors.userNationalId.message}
              </Form.Text>
            )}
          </Form.Group>
        )}
        {WithCreatePayment&&
        <Form.Group
        className=" input input-md"
        style={{ flex: "1" }}
        controlId="phoneNumber"
      >
        <Form.Label >رقم الهاتف للمقدم</Form.Label>
        <Form.Control
          {...paymentNumberRegister("phoneNumber", {
            required: "الرجاء رقم الهاتف",
            pattern: {
              value: /^078[0-9]*$|^077[0-9]*$|^079[0-9]*$/,
              message: "الرجاء ادخال رقم هاتف صحيح",
            },
            minLength: {
              value: 10,
              message: "يجب أن يحتوي الحقل على 10 ارقام",
            },
            maxLength: {
              value: 10,
              message: "يجب أن يحتوي الحقل على 10 ارقام",
            },
          })}
        />
      </Form.Group>}
      <div className="mb-3"></div>

        
      {!WithCreatePayment&&
      <Form.Group className="mb-3 input input-md" controlId="ParcelsSearch-1">
        <Form.Label>مقياس الرسم</Form.Label>
        <Form.Select
          name="scale"
          defaultValue="2000"
          onChange={handleScaleChange}>
          <option value="250">250</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
          <option value="1500">1500</option>
          <option value="2000">2000</option>
          <option value="2500">2500</option>
          <option value="5000">5000</option>
          <option value="10000">10000</option>
          <option value="15000">15000</option>
          <option value="20000">20000</option>
          <option value="25000">25000</option>
          <option value="30000">30000</option>
          <option value="40000">40000</option>
          <option value="50000">50000</option>
          <option value="75000">75000</option>
          <option value="100000">100000</option>
          <option value="">Auto</option>
        </Form.Select>
      </Form.Group>}
      
      {WithCreatePayment? <button
        type="button"
        className="btn btn--primary w-100"
        onClick={CreatePaymentCode}
      >
        {loadingCreatePayment?"تحميل ...":"طلب أصدار مخطط"}
      </button>:
      <button
        type="button"
        className="btn btn--primary w-100"
        onClick={handlePrint}
      >
        طباعة
      </button>}
    </div>
  );
}

PrintParcels.defaultProps = {
  printData: {},
  toggleDialog: () => {},
  isDraft: false,
  isOfficial: false,
  isGovernmentWork: false,
  isPrivateOfficialWork: false,
  withCheck: false,
};
PrintParcels.propTypes = {
  printData: PropTypes.object,
  toggleDialog: PropTypes.func,
  isDraft: PropTypes.bool,
  isOfficial: PropTypes.bool,
  isGovernmentWork: PropTypes.bool,
  isPrivateOfficialWork: PropTypes.bool,
  withCheck: PropTypes.bool,
};
export default PrintParcels;
